import { useNavigate, useLocation } from 'react-router-dom';
import { Avatar } from '@mui/material';
import { CircleButton } from '../../styles/CustomButtons';
import { useUIState } from '../../context/uiState';
import { UIStateType } from '../../context/uiState/context';
import { useUserPicture } from '@features/user';
import { useEventTracking } from '@services/statsig';

const UserMenuButton = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setState } = useUIState();
  const userPicture = useUserPicture();
  const { navigation: navigationMetrics } = useEventTracking();

  return (
    <CircleButton
        onClick={() => {
          // Track user avatar click navigation
          navigationMetrics.clicked({
            menu_item: 'user_avatar',
            source_path: location.pathname,
            destination_path: '/user',
            is_dropdown: false,
          });
          setState((prevState: UIStateType) => ({
            ...prevState,
            navigation: { currentPage: 'user' },
          }));
          navigate('/user');
        }}
        sx={{ position: 'relative' }}
      >
        <Avatar variant="circular" src={userPicture} alt="user photo"></Avatar>
      </CircleButton>
  );
};

export default UserMenuButton;
